const stripWrappingQuotes = (value = "") => value.replace(/^['"]|['"]$/g, "");

const isLocalDevelopmentHost = (hostname = "") => {
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.startsWith("192.168.") ||
    hostname.startsWith("10.") ||
    /^172\.(1[6-9]|2\d|3[0-1])\./.test(hostname)
  );
};

export const getConfiguredApiBaseUrl = () =>
  stripWrappingQuotes(process.env.REACT_APP_SERVER_URL || "");

export const getConfiguredProxyTarget = () =>
  stripWrappingQuotes(process.env.REACT_APP_PROXY_TARGET || "");

export const getApiBaseUrl = () => {
  const configuredApiBaseUrl = getConfiguredApiBaseUrl();
  const configuredProxyTarget = getConfiguredProxyTarget();
  const isDevelopment = process.env.NODE_ENV === "development";

  if (
    isDevelopment &&
    configuredProxyTarget &&
    typeof window !== "undefined" &&
    isLocalDevelopmentHost(window.location.hostname)
  ) {
    return "/api/v1";
  }

  return configuredApiBaseUrl || "/api/v1";
};

export const getBackendOrigin = () => {
  const proxyTarget = getConfiguredProxyTarget();
  if (
    proxyTarget &&
    !(
      process.env.NODE_ENV === "development" &&
      typeof window !== "undefined" &&
      isLocalDevelopmentHost(window.location.hostname)
    )
  ) {
    return proxyTarget;
  }

  const configuredApiBaseUrl = getConfiguredApiBaseUrl();
  if (configuredApiBaseUrl.startsWith("http://") || configuredApiBaseUrl.startsWith("https://")) {
    try {
      return new URL(configuredApiBaseUrl).origin;
    } catch (error) {
      return configuredApiBaseUrl;
    }
  }

  if (typeof window !== "undefined") {
    return window.location.origin;
  }

  return "";
};

export const resolveApiUrl = (path = "") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const baseUrl = getApiBaseUrl();

  if (baseUrl.startsWith("http://") || baseUrl.startsWith("https://")) {
    return `${baseUrl}${normalizedPath}`;
  }

  return `${baseUrl}${normalizedPath}`;
};

export const resolveBackendUrl = (path = "") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${getBackendOrigin()}${normalizedPath}`;
};
